export default __webpack_public_path__ + "b4f3b958f4a019862d81b15f3f8eee3a.svg";